;(function ($) {
  /*
   *  new_map
   *
   *  This function will render a Google Map onto the selected jQuery element
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$el (jQuery element)
   *  @return	n/a
   */

  var currentInfoWindow = null

  function new_map($el) {
    //var center = parseInt($el.attr('data-zoom'));
    //var zoom = parseInt($el.attr('data-zoom'));
    //var zoom = 10;
    var zoom = 14

    // var
    var $markers = $el.find('.marker')

    // vars
    var args = {
      zoom: zoom,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
      },
      center: new google.maps.LatLng(0, 0),
      scaleControl: false,
      scrollwheel: false,
      navigationControl: false,
      streetViewControl: false,
      mapTypeControl: false,
    }

    // Map Styles
    var mapStyles = [
      {
        stylers: [{ saturation: -100 }, { lightness: 20 }],
      },
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }],
      },
    ]

    // create map
    var map = new google.maps.Map($el[0], args)

    map.setOptions({ styles: mapStyles })

    // add a markers reference
    map.markers = []

    // add markers
    $markers.each(function () {
      add_marker($(this), map)
    })

    // center map
    //center_map( map );
    center_map(map, zoom)
    $(window).resize(function () {
      center_map(map, zoom)
    })

    // return
    return map
  }

  /*
   *  add_marker
   *
   *  This function will add a marker to the selected Google Map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$marker (jQuery element)
   *  @param	map (Google Map object)
   *  @return	n/a
   */

  function add_marker($marker, map) {
    // var
    var latlng = new google.maps.LatLng(
      $marker.attr('data-lat'),
      $marker.attr('data-lng')
    )
    //var markerColor = $marker.attr('data-marker-color');

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      draggable: false,
      animation: google.maps.Animation.DROP,
      title: 'GIZEH',
      icon: new google.maps.MarkerImage(
        //'/typo3conf/ext/yt_gizeh/Resources/Public/images/marker-' + markerColor + '.png',
        '/typo3conf/ext/yt_gizeh/Resources/Public/images/marker.png',
        new google.maps.Size(30, 37),
        new google.maps.Point(0, 0),
        new google.maps.Point(15, 37)
      ),
    })

    // add to array
    map.markers.push(marker)

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      })

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function () {
        //infowindow.open( map, marker );
        if (currentInfoWindow != null) {
          currentInfoWindow.close()
        }
        infowindow.open(map, marker)
        currentInfoWindow = infowindow
      })
    }
  }

  /*
   *  center_map
   *
   *  This function will center the map, showing all markers attached to this map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	map (Google Map object)
   *  @return	n/a
   */

  function center_map(map, zoom) {
    // vars
    var bounds = new google.maps.LatLngBounds()

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      )

      bounds.extend(latlng)
    })

    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter())
      map.setZoom(zoom)
    } else {
      // fit to bounds
      map.fitBounds(bounds)
    }
  }

  // Map nach erstem Marker zentrieren
  function center_map_firstMarker(map, zoom) {
    // vars
    var bounds = new google.maps.LatLngBounds()
    var markerIteration = 1

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
      if (markerIteration < 2) {
        var latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        )
        bounds.extend(latlng)
        markerIteration++
      }
    })

    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter())
      map.setZoom(zoom)
    } else {
      // fit to bounds
      map.fitBounds(bounds)
    }
  }

  /**
   * init maps
   */

  var map = null
  window.initMaps = function () {
    if (map) {
      $('.map-gizeh').show()
    } else {
      $('.map-gizeh')
        .show()
        .each(function () {
          map = new_map($(this))
        })
    }
  }

  /**
   * show/hide maps on consent update
   */

  window.addEventListener('DOMContentLoaded', function () {
    if (usercentrics.getConsents('S1pcEj_jZX').consentStatus) {
      initMaps()
      $('.map-gizeh').show()
      $('.map-gizeh').addClass('map-loaded')
    } else {
      $('.map-gizeh').hide()
      $('.map-gizeh').removeClass('map-loaded')
    }
  })

  window.addEventListener('onConsentStatusChange', function () {
    if (usercentrics.getConsents('S1pcEj_jZX').consentStatus) {
      initMaps()
      $('.map-gizeh').show()
      $('.map-gizeh').addClass('map-loaded')
    } else {
      $('.map-gizeh').hide()
      $('.map-gizeh').removeClass('map-loaded')
    }
  })
})(jQuery)



// WEBPACK FOOTER //
// ./js/parts/googleMap.js